<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="autoclaim"
        @save="saveResellerFormData">
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="autoclaim-Sachbearbeiter"
                :options-loader="loadResellerUserOptions"
                property="resellerUser"
                :required="true"
                type="autocomplete">
                <template v-slot:display-value>
                    <p>
                        <span v-if="userData.name"><b>{{ userData.name }}</b><br/></span>
                        <span v-if="userData.street">{{ userData.street }}<br/></span>
                        <span v-if="userData.postalCode || userData.place">
                        {{ userData.postalCode }} {{ userData.place }}<br/>
                    </span>
                        <span v-if="userData.countryName">{{ userData.countryName }}<br/></span>
                    </p>
                    <p>
                        <span v-if="userData.phone">{{ userData.phone }}<br/></span>
                        <span v-if="userData.email">
                        <a :href="'mailto:' + userData.email">{{ userData.email }}</a>
                    </span>
                    </p>
                </template>
            </csp-desktop-info-card-element>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
import Container from '@services/Container';
import FormDataMixin from '../../mixins/FormDataMixin';

const container = Container.getInstance();

const recordRepository = container.getDesktopRecordRepository();

export default {
    name: 'ParticipantReseller',
    mixins: [FormDataMixin],
    computed: {
        recordId() {
            return this.$route.params.recordId;
        },
        userData() {
            return {
                'name': this.formContext.form.getProperty('userName') ?? '',
                'street': this.formContext.form.getProperty('userStreet') ?? '',
                'postalCode': this.formContext.form.getProperty('userPostalCode') ?? '',
                'place': this.formContext.form.getProperty('userPlace') ?? '',
                'countryName': this.formContext.form.getProperty('userCountryName') ?? '',
                'phone': this.formContext.form.getProperty('userPhone') ?? '',
                'email': this.formContext.form.getProperty('userEmail') ?? '',
            };
        },
    },
    methods: {
        loadResellerUserOptions() {
            return recordRepository.loadResellerUserOptions(this.recordId);
        },
        saveResellerFormData(formContext) {
            const saveFunction = (objectId, postData) => {
                return recordRepository.saveParticipantsReseller(this.recordId, postData)
            }
            this.saveFormData(formContext, saveFunction, null);
        },
    },
}
</script>
